import request from '../request';

export function getWarehouse(params) {
  return request({
    url: "directories/warehouses",
    method: "get",
    params
  })
}

export function getWarehouseID(id) {
  return request({
    url: `/directories/warehouses/${id}`,
    method: "get"
  })
}

export function getPageWarehouse(id) {
  return request({
    url: `/directories/warehouses?page=${id}`,
    method: "get"
  })
}

export function postWarehouse(data) {
  return request({
    url: "directories/warehouses",
    method: "post",
    data
  })
}

export function putWarehouse(data) {
  return request({
    url: `/directories/warehouses/${data.get("id")}`,
    method: "post",
    data
  })
}

export function deleteWarehouse(id) {
  return request({
    url: `/directories/warehouses/${id}`,
    method: "delete",
  })
}